export default function mixpanelTracker (variant) {
  return {
    /**
     * track mixpanel event
     * @param {String} event
     * @param {Object?} properties
     */
    track (event, properties) {
      const allProperties = {
        ...properties,
        Variant: variant,
      };

      return new Promise((resolve) => {
        if (window.mixpanel) {
          window.mixpanel.track(event, allProperties, resolve);
        } else {
          console.warn(event, allProperties);
          resolve(false);
        }
      });
    },

    /**
     * track for Siempre Plus Sign In Click
     * @param { String } card
     */
    trackSignInClick (card) {
      return this.track('Siempre Plus Sign In Click', {
        'Siempre Plus Card': card,
      });
    },

    /**
     * track for Siempre Plus Sign In
     * @param {{ Type: String, 'Siempre Plus Card': String }} properties
     */
    trackSignIn (properties) {
      return this.track('Siempre Plus Sign In', properties);
    },

    /**
     * track for Siempre Plus Forgot Password
     * @param {String} email
     */
    trackForgotPassword (email) {
      return this.track('Siempre Plus Forgot Password', { Email: email });
    },

    /**
     * track for Siempre Plus Sign Up
     * @param {{
     *   'Type': String,
     *   'Name': String,
     *   'Email': String,
     *   'Siempre Plus Card': String
     * }} properties
     */
    trackSignUp (properties) {
      return this.track('Siempre Plus Sign Up', properties);
    },

    /**
     * track for Siempre Plus Sign Out
     * @param {string} card
     */
    trackSignOut (card) {
      return this.track('Siempre Plus Sign Out', { 'Siempre Plus Card': card });
    },
  };
}



// WEBPACK FOOTER //
// ./utils/mixpanelTracker.js